<template>
  <footer class="footer">
    <nav class="navbar navbar-light">
      <ul class="nav navbar-nav">
        <li class="nav-item">
          <a class="nav-link" href="http://www.google.com"><i class="fa fa-google-plus-square" aria-hidden="true"></i></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="http://facebook.com"><i class="fa fa-facebook-square" aria-hidden="true"></i></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="http://twitter.com"><i class="fa fa-twitter-square" aria-hidden="true"></i></a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Déclarer un bug</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Formation</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Forum</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#">Contact</a>
        </li>
        <li class="nav-item">
          <span class="navbar-text">Copyright 21 Interactive</span>
        </li>
      </ul>
    </nav>
  </footer>
</template>

<script>
  export default{
    vuex: {
      getters: {
      }
    },
    data () {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// Footer.vue?5511721c